<ng-container *ngTemplateOutlet="entryTemplate!"></ng-container>